export const KANBAN = '@KANBAN';

export const actionCreators = {
    kanban: () =>  ({ type: KANBAN }),
};
